import styled, { css } from 'styled-components';
import { suppressProps, makeBoxShadow } from '../../utils/index.js';
import { Paragraph } from '../paragraph/index.js';
import { Link } from '../link/index.js';
import { Button } from '../button/index.js';
import { Flex } from '../flex/index.js';
export const IconContainer = styled.div(({ theme }) => css `
    line-height: ${theme.lineHeights[theme.styles.paragraphs.smallEmphasised.lineHeight]};

    svg {
      block-size: ${theme.lineHeights[theme.styles.paragraphs.smallEmphasised.lineHeight]};
    }
  `);
export const Content = styled.div.withConfig(suppressProps('actionPosition')) `
  display: grid;
  ${({ actionPosition }) => {
    if (actionPosition === 'inline')
        return css `
        grid-template-areas:
          'label action'
          'description .';
      `;
    return css `
      grid-template-areas:
        'label'
        'description'
        'action';
    `;
}}
`;
export const Label = styled(Paragraph).attrs({ variant: 'smallEmphasised' }) `
  grid-area: label;
  color: inherit;
`;
export const Description = styled(Paragraph).attrs({ variant: 'small' }) `
  grid-area: description;
  color: inherit;
`;
export const Action = styled(Link).attrs({
    setting: 'inline',
    variant: 'emphasised',
})(({ theme }) => {
    const { smallEmphasised } = theme.styles.paragraphs;
    return css `
      grid-area: action;
      color: inherit;
      font-size: ${theme.fontSizes[smallEmphasised.fontSize]};
      line-height: ${theme.lineHeights[smallEmphasised.lineHeight]};
      letter-spacing: ${theme.letterSpacings[smallEmphasised.letterSpacing]};
      width: fit-content;
    `;
}, ({ position, theme }) => {
    if (position === 'inline')
        return css `
        justify-self: end;
        margin-left: ${theme.space.x4};
      `;
    return css `
      margin-top: ${theme.space.x2};
    `;
});
export const CloseContainer = styled.div ``;
export const CloseButtonElement = styled(Button).attrs({ variant: 'plain' }) ``;
export const NotificationElement = styled(Flex).withConfig(suppressProps('status', 'variant', 'isOnGray'))(({ theme, variant, status }) => {
    const statusOptions = theme.styles.notifications.status[status];
    const variantOptions = theme.styles.notifications.variant[variant];
    return css `
      color: ${theme.colors.text[statusOptions.color]};
      background-color: ${theme.colors.backgrounds[statusOptions.backgroundColor]};
      border-color: ${theme.colors.text[statusOptions.borderColor]};
      border-style: ${theme.borderStyles[variantOptions.borderStyle]};
      border-width: ${theme.borderWidths[variantOptions.borderWidth]};
      border-radius: ${theme.radii[variantOptions.borderRadius]};
      padding: ${theme.space[variantOptions.padding]};
      width: ${variantOptions.width};

      ${IconContainer} {
        margin-right: ${theme.space.x2};
      }

      ${Content} {
        flex-basis: 0%;
        flex-grow: 1;
      }

      ${CloseContainer} {
        margin-left: ${theme.space.x4};
      }
    `;
}, ({ theme, variant, status }) => {
    if (variant !== 'toast')
        return css ``;
    const statusOptions = theme.styles.notifications.status[status];
    const getShadow = (style, color = statusOptions.shadowColor) => makeBoxShadow({ color, style, alpha: 'x1' }, theme);
    return css `
      box-shadow: ${getShadow('broad')}, ${getShadow('narrow')},
        ${getShadow('border', 'secondary')};
    `;
}, ({ theme, ...props }) => {
    if (props.isOnGray &&
        props.status === 'info' &&
        props.variant === 'sectionBanner')
        return css `
        color: ${theme.colors.text.default};
        background-color: ${theme.colors.backgrounds.secondaryOnGray};
      `;
    return css ``;
});
//# sourceMappingURL=notification.styles.js.map